/**
 * Parse the catalog-recommended quantity for a part into a usable cart quantity.
 *
 * EPC/microcat catalogs emit a per-part `quantity` (the number of that part used
 * in the assembly) as a STRING, e.g. "1", "2", or sometimes a non-numeric token
 * like "AR" (as required). We coerce to a positive integer and fall back to 1 for
 * anything missing / non-numeric / < 1, so a part always enters the cart with at
 * least one unit.
 */
export function parseCatalogQuantity(raw: unknown): number {
  const n = parseInt(String(raw ?? ''), 10);
  return Number.isFinite(n) && n >= 1 ? n : 1;
}
